/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventUuidListDto } from '../../models/event-uuid-list-dto';

export interface ScoutingControllerEventsBulkActions$Params {
  action: 'delete' | 'favorite' | 'unfavorite';
      body: EventUuidListDto
}

export function scoutingControllerEventsBulkActions(http: HttpClient, rootUrl: string, params: ScoutingControllerEventsBulkActions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, scoutingControllerEventsBulkActions.PATH, 'post');
  if (params) {
    rb.path('action', params.action, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

scoutingControllerEventsBulkActions.PATH = '/scouting/events/bulk/{action}';
